import { useCallback, useMemo, useSyncExternalStore } from 'react';

import { currentUserQuery } from '@futrli/views/queries/currentUser';

/**
 * Loads the current user data
 */
export const useLoadUserData = () => {
  const query = useMemo(() => currentUserQuery(), []);
  const subscribe = useCallback((onStoreChange: () => void) => query.subscribe(onStoreChange), [query]);
  const getSnapshot = useCallback(() => query.getCurrentResult(), [query]);
  const result = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  const reload = useCallback(async () => {
    await query.refetch();
  }, [query]);

  return {
    reload,
    data: result.data,
    error: result.error,
    isLoading: result.isFetching,
    isLoadingOrInit: result.isPending || result.isFetching
  };
};
